<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-26 18:15:08
 * @LastEditTime: 2021-01-20 11:31:26
 * @LastEditors: daikeyi
 -->
<template>
    <div id='page_Container'>
        <div class="page">
            <div id='main-container' class="main-container" >
                <div class='choiceAddress'>
                    <van-radio-group v-model="radio" @change="activityGroupChange">
                        <van-cell-group >
                            <van-cell title=""  v-for='(item) in addressList' :key='item.id' clickable @click="choose(item)">
                                <div class="flex address-div">
                                    <div class='address-value'>
                                        <p class="flex">收货人：{{item.receiver}}<span class="left-span">{{item.mobileNumber}}</span></p>
                                        <p><span v-if='item.defaultFlag === 1' class="right-span">默认</span>收货地址：{{item.area}} {{item.address}}</p>
                                    </div>
                                    <van-radio :name='item.id'/>
                                </div>

                            </van-cell>
                        </van-cell-group>
                    </van-radio-group>
                </div>
            </div>
            <div class="addAddress" @click="creatAddress">新增收货地址</div>
            <van-popup v-model="show" position="right" :overlay="false" class='creatRight'>
                <div class='creatAddress'>
                    <van-cell-group>
                        <van-field required v-model="Consignee" label="收货人：" placeholder="请输入收货人" :error-message="consigneeError" @focus='focusInput' />
                        <van-field required v-model="mobileNumber" label="联系电话：" placeholder="请输入联系电话" :error-message="phoneError" @focus='focusInput' />
                    </van-cell-group>
                    <van-cell-group class='mt12'>
                        <van-cell required title="所在地区：" is-link :value="addressValue" @click='chooseAddress' />
                        <van-field required v-model="DetailedAddress" label="详细地址：" :maxlength='50' type="textarea" placeholder="请输入详细地址" @focus='focusInput' rows="1" autosize :error-message="addressError" />
                        <van-cell title='设为默认地址' label="注：每次下单将默认该地址为收货地址">
                            <van-switch v-model="checked" />
                        </van-cell>
                    </van-cell-group>
                </div>
                <div class='btnStyle'>
                    <van-button round type="danger" @click='saveAddress' :loading='saveLoading' v-if='isEditShow'>添加</van-button>
                    <van-button round @click='cancel' :disabled='cancelButton' style='margin-top:15px;'>取消</van-button>
                </div>
            </van-popup>
            <van-popup v-model="addressShow" position="bottom" :overlay="false">
                <van-area :area-list="areaList" value="110101" @cancel='cancelArea' @confirm='confirmArea' />
            </van-popup>
        </div>
    </div>
</template>
<script>
import { Toast, Dialog } from 'vant';
import { toastLoading, clearToastLoading } from '@/utils/base/utils';
import { mapGetters, mapActions } from 'vuex';
export default {
    computed: {
        ...mapGetters(['addressBeginId', 'deliveryArr'])
    },
    data() {
        return {
            once: true,
            addressShow: false,
            areaList: {},
            checked: true,
            isEditShow: true,
            saveLoading: false,
            cancelButton: false,
            show: false,
            consigneeError: '',
            phoneError: '',
            mobileNumber: '',
            addressValue: '',
            addressError: '',
            DetailedAddress: '',
            Consignee: '',
            radio: '-1',
            areaId: '',
            addressList: [],
            requireInfo: {},
            requireInfoall: {},
            orderRespDTOList: [],
            orderJsonList: [],
            // addressBeginId: 0,
            arr: []
        };
    },
    esvShow() {
        const ths = this;
        document.title = '选择地址';
        this.once = true;
        this.ESVStorage.getSavedValue('invoiceArr', (data) => {
            ths.arr = data;
        });
        // this.ESVStorage.getSavedValue('addressBegin', (data) => {
        //     console.log('id:' + data);
        //     ths.addressBeginId = parseInt(data);
        //     if (data) {
        //         ths.radio = data;
        //     } else {
        //         this.ESVStorage.getSavedValue('requireInfo', (data) => {
        //             ths.requireInfo = data;
        //             if (this.requireInfo.defaultAddress !== undefined) {
        //                 this.radio = this.requireInfo.defaultAddress.id;
        //             }
        //         });
        //     }
        // });
        ths.radio = ths.addressBeginId;

        this.ESVStorage.getSavedValue('objCoupon', (data) => {
            ths.objCoupon = data;
        });

        this.queryAddress();
        this.queryAddressSS();
        this.ESVStorage.getSavedValue('requireInfoall', (data) => {
            ths.requireInfoall = data;
            this.orderRespDTOList = this.requireInfoall.orderRespDTOList;
        });
        this.ESVStorage.getSavedValue('usePointFlag', (data) => {
            ths.usePointFlag = data;
        });

        let arr = [];
        this.ESVStorage.getSavedValue('fullArr', (data) => {
            this.fullArr = data;
        });
        this.orderRespDTOList.forEach((item, index) => {
            item.value.memberOrderItemList.forEach((itemNew, index) => {
                // debugger;
                arr.push({
                    productId: itemNew.productId,
                    skuCode: itemNew.skuCode,
                    quantity: itemNew.quantity,
                    deliveryMethodCode: item.value.deliveryMethodCode
                });
            });
            this.orderJsonList.push({
                orderItemJsonList: arr,
                participate: ((item.value.activeList && item.value.activeList.length <= 0) || this.fullArr[index] === -1) ? 2 : 1,
                remark: item.value.remark,
                invoiceType: this.arr[index] && this.arr[index].invoiceType ? this.arr[index].invoiceType : '',
                invoiceTitleType: this.arr[index] && this.arr[index].invoiceTitleType ? this.arr[index].invoiceTitleType : '',
                invoiceTitle: this.arr[index] && this.arr[index].invoiceTitle ? this.arr[index].invoiceTitle : '',
                taxNumber: this.arr[index] && this.arr[index].taxNumber ? this.arr[index].taxNumber : '',
                depositBank: this.arr[index] && this.arr[index].depositBank ? this.arr[index].depositBank : '',
                bankAccount: this.arr[index] && this.arr[index].bankAccount ? this.arr[index].bankAccount : '',
                enterpriseAddress: this.arr[index] && this.arr[index].enterpriseAddress ? this.arr[index].enterpriseAddress : '',
                enterprisePhone: this.arr[index] && this.arr[index].enterprisePhone ? this.arr[index].enterprisePhone : ''
            });
            arr = [];
        });
        window.addEventListener(
            'popstate',
            function(e) {
                if (ths.show) {
                    ths.show = false;
                    ths.$router.go(-1);
                }
            },
            false
        );
    },
    esvReady() {

    },
    methods: {
        ...mapActions(['setAddressBeginId']),
        queryAddress() {
            const ths = this;
            ths.$doRequest(
                {
                    url: '/address/queryMemberShippingAddressList',
                    params: {

                    },
                    before: function() {
                        ths.loading = toastLoading();
                    },
                    complete: function() {
                        clearToastLoading(ths.loading);
                    }
                },
                (data) => {
                    if (data.responseCode === '100000') {
                        ths.addressList = data.result;
                        if (ths.radio === '-1') {
                            let flag = false;
                            ths.addressList.forEach((item, index) => {
                                if (item.defaultFlag === 1) {
                                    flag = true;
                                    ths.radio = item.id;
                                    ths.ESVStorage.putSavedValue('addressBegin', item.id);
                                    ths.$set(ths.requireInfo, 'defaultAddressFlag', '2');
                                    ths.$set(ths.requireInfo, 'defaultAddress', item);
                                    ths.ESVStorage.putSavedValue('requireInfo', ths.requireInfo);
                                }
                            });
                            this.once = flag;
                        }
                        ths.setAddressBeginId(ths.radio);
                    }
                }
            );
        },
        queryAddressSS() {
            const ths = this;
            ths.$doRequest(
                {
                    url: '/region/queryCommonRegionList',
                    params: {

                    },
                    complete: function() {}
                },
                function(data) {
                    ths.areaList = data.result;
                }
            );
        },
        activityGroupChange(name) {
            if (!this.once) {
                // 根据id 获取item数据
                let activityItem = {};
                for (let i = 0; i < this.addressList.length; i++) {
                    const item = this.addressList[i];
                    if (item.id === name) {
                        activityItem = item;
                        break;
                    }
                }
                this.$set(this.requireInfo, 'defaultAddressFlag', '2');
                this.$set(this.requireInfo, 'defaultAddress', activityItem);
                // 地址
                this.ESVStorage.putSavedValue('addressBegin', activityItem.id);
                this.setAddressBeginId(activityItem.id);
                this.ESVStorage.putSavedValue('requireInfo', this.requireInfo);
                this.confirmOrderNew(activityItem);
                console.log(name);
            } else {
                this.once = false;
            }
        },
        choose(item) {
            console.log(item, 'choose');

            // let ths = this;
            this.radio = item.id;
            if (this.radio === this.addressBeginId) {
                this.$set(this.requireInfo, 'defaultAddressFlag', '2');
                this.$set(this.requireInfo, 'defaultAddress', item);
                // 地址
                this.ESVStorage.putSavedValue('addressBegin', item.id);
                this.setAddressBeginId(item.id);
                this.ESVStorage.putSavedValue('requireInfo', this.requireInfo);
                this.confirmOrderNew(item);
            }
        },
        confirmOrderNew(item) {
            // debugger;
            const ths = this;
            const params = {
                areaId: item.areaId,
                usePointFlag: ths.usePointFlag,
                // couponCode: ths.objCoupon && ths.objCoupon.couponCode !== '-1' ? ths.objCoupon.couponCode : '',

                couponCode: this.$route.params.genericCouponCode,
                orderJsonList: JSON.stringify(ths.orderJsonList)
            };
            if (this.$route.params.productGroupId || Number(this.$route.params.productGroupId) === 0) {
                params.productGroupId = this.$route.params.productGroupId;
            }
            ths.$doRequest(
                {
                    url: '/order/confirmOrderNew',
                    params: params,
                    // complete: function() {
                    //     ths.saveLoading = false;
                    // }
                    before: function() {
                        ths.loading = toastLoading();
                    },
                    complete: function() {
                        clearToastLoading(ths.loading);
                        ths.saveLoading = false;
                    }
                },
                (data) => {
                    // debugger;
                    ths.orderRespDTOList = data.result.orderRespDTOList;
                    ths.requireInfoall = data.result;

                    ths.orderRespDTOList.forEach((itemNew, index) => {
                        // if (itemNew.value.activeList.length > 0) {
                        //     // itemNew.value.activeList.push({activityId: -1,
                        //     //     activityTitle: '不参加活动',
                        //     //     activityType: 4
                        //     // });
                        // }
                        itemNew.value = { ...itemNew.value, ...this.deliveryArr[index] };
                        itemNew.invoice = ths.arr[index];
                    });
                    // ths.ESVStorage.getSavedValue('requireInfoall', data => {
                    //     console.log(222);
                    //     console.log(data);
                    //     if (data.usePoint) {
                    //         ths.requireInfoall.usePoint = data.usePoint;
                    //     }
                    //     if (data.sumPayAmount) {
                    //         ths.requireInfoall.sumPayAmount = data.sumPayAmount;
                    //     }
                    ths.ESVStorage.putSavedValue('requireInfoall', ths.requireInfoall);
                    setTimeout(() => {
                        ths.esvBackPage(1);
                    }, 0);
                    // });
                    // ths.esvOpenPage('OPConfirmOrder');
                }
            );
        },
        creatAddress() {
            if (this.addressList.length >= 5) {
                Dialog.alert({
                    title: '',
                    message: '最多设置5个地址'
                }).then(() => {});
                return false;
            }
            this.show = true;
            this.isEditShow = true;
            this.Consignee = '';
            this.mobileNumber = '';
            this.addressValue = '';
            this.DetailedAddress = '';
            this.checked = true;
        },
        saveAddress() {
            const ths = this;

            if (ths.Consignee.length <= 0) {
                // ths.consigneeError = '收货人不能为空';
                Toast('收货人不能为空');
                return false;
            }
            if (ths.mobileNumber.length <= 0) {
                // ths.phoneError = '联系电话不能为空';
                Toast('联系电话不能为空');
                return false;
            }
            if (!/^0[0-9]{2,3}-[0-9]{7,8}$/.test(ths.mobileNumber) && !/^1[3456789][0-9]{9}$/.test(ths.mobileNumber)) {
                // ths.phoneError = '请输入合法的号码';
                Toast('请输入合法的号码');
                return false;
            }
            if (ths.addressValue.length <= 0) {
                Toast('所在地区不能为空');
                return false;
            }
            if (ths.DetailedAddress.length <= 0) {
                // ths.addressError = '详细地址不能为空';
                Toast('详细地址不能为空');
                return false;
            }
            ths.saveLoading = true;
            const params = {
                mobileNumber: ths.mobileNumber,
                receiver: ths.Consignee,
                area: ths.addressValue,
                areaId: ths.areaId,
                address: ths.DetailedAddress,
                defaultFlag: ths.checked === true ? 1 : 2
            };
            ths.$doRequest(
                {
                    url: '/address/saveMemberShippingAddress',
                    params: params,
                    // complete: function() {
                    //     ths.saveLoading = false;
                    // },
                    before: function() {
                        ths.saveLoading = true;
                        ths.loading = toastLoading();
                    },
                    complete: function() {
                        clearToastLoading(ths.loading);
                        ths.saveLoading = false;
                    }
                },
                function(data) {
                    if (data.responseCode === '100000') {
                        ths.queryAddress();
                        ths.show = false;
                    }
                }
            );
        },
        focusInput() {
            const ths = this;
            ths.addressShow = false;
            ths.consigneeError = '';
            ths.phoneError = '';
            ths.addressError = '';
        },
        chooseAddress() {
            this.addressShow = true;
            this.cancelButton = true;
        },
        cancel() {
            this.show = false;
        },
        cancelArea() {
            this.addressShow = false;
            this.cancelButton = false;
        },
        confirmArea(data) {
            let value = '';
            let id = '';
            data.forEach(function(val, index) {
                value += val.name + '-';
                id += val.code + ',';
            });
            value = value.substring(0, value.length - 1);
            id = id.substring(0, id.length - 1);
            this.addressValue = value;
            this.areaId = id;
            this.addressShow = false;
            this.cancelButton = false;
        }
    }
};
</script>
<style lang="scss" scoped>
.choiceAddress {
    // padding: 0 12px;
    background: #fff;
    .van-cell{
        padding:10px 0;
        .van-cell__title {
        // TODO
            flex: none !important;
            max-width: 220px !important;
            width: auto !important;
        }
    }
}
.address-div {
    padding: 0 12px;
    .address-value {
        text-align: left;
        color:#414141;
        padding-right: 20px;
        width: 100%;
        p {

            // &:not(:last-child) {
            //     display: inline-flex;
            //     justify-content: space-between;
            // }
        }
        .left-span {
            // float: right;
        }
        .right-span {
            padding:0 6px;
            color:orange;
            border:1px solid orange;
            margin-right:5px;
        }
    }
    /deep/ .van-radio {
        flex: none;
    }
}

.addAddress{
    background: #ee2e50;
    height: 50px;
    line-height: 50px;
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    text-align: center;
    color: #fff;
    cursor: pointer;
}
.creatRight {
    width: 100%;
    height: 100%;
    background: #f2f2f2;
}
.btnStyle {
    text-align: center;
    margin: 25px 0;
    .van-button {
        width: 80%;
    }
    .van-button--danger {
        background: #ee2e50;
        border: 1px solid #ee2e50;
    }
}
</style>
